import { useEffect, useState } from "react";
import { ConnectionName, ConnectionType } from "@arelia-types/connection";
import ConnectionsPresenter from "./ConnectionsPresenter";
import { useConnections } from "../../../api/connections";
import { authWindowName } from "./constants";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import LogoutForm from "@arelia-components/api-authorization/LogoutForm";
import { Box, Button } from "@mui/material";
import { PATHS } from "src/routes";
import { useLocation, useNavigate } from "react-router-dom";
import { useConnectionsDto, useActiveConnections, useViewConnections } from "./hooks";
import ConnectionsContext from "./ConnectionsContext";
import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";

export default function ConnectionsContainer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [activeConnections, setActiveConnections] = useActiveConnections();
  const [filter, setFilter] = useState<ConnectionType | null>(null);
  const navOptions = [
    { value: PATHS.PROFILE, label: "Profile" },
    { value: PATHS.CONNECTIONS, label: "Connections" },
    { value: PATHS.SUBSCRIPTION, label: "Subscription" },
    { value: PATHS.SECURITY, label: "Security" }
  ];

  const action = <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} flexGrow="1">
    <LogoutForm>
      <Button type="submit" variant="contained" color="secondary">Logout</Button>
    </LogoutForm>
  </Box>;

  const { isLoading, isError, data: connectionsResponse, refetch: reloadConnections } = useConnections({
    initialData: []
  });

  const connections = useConnectionsDto(connectionsResponse);
  const viewConnections = useViewConnections(activeConnections, connections, filter);

  useEffect(() => {
    if (connectionsResponse) {
      const saved = localStorage.getItem('activeConnections');
      const parsed = saved && JSON.parse(saved) as ConnectionName[];

      const activeConnections = connectionsResponse
        .filter(c => c.connected && !parsed?.includes(c.name))
        .map(c => c.name);

      setActiveConnections([...activeConnections, ...parsed as ConnectionName[]]);
    }
  }, [connectionsResponse]);

  useEventListeners(["message"], (e: any) => {
    if (e && e.source.name === authWindowName && e.data.reload) {
      reloadConnections();
    }
  });

  return (
    <ContentBox>
      <Header
        title="Account"
        action={action}
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />
        <ConnectionsContext.Provider value={{
          connectionsDto: connections,
          viewConnections: viewConnections,
          activeConnections: activeConnections,
          setActiveConnections: setActiveConnections
        }}>
          <ConnectionsPresenter
            loading={isLoading}
            error={isError}
          >
            <MenuSelector
              menuType={MenuType.contained}
              menuItems={[
                { label: 'All', value: null },
                { label: 'Streaming', value: ConnectionType.streaming },
                { label: 'Social', value: ConnectionType.social },
                { label: 'Earnings', value: ConnectionType.earnings },
              ]}
              selectedValue={filter}
              onClick={value => setFilter(value)}
            />
          </ConnectionsPresenter>
        </ConnectionsContext.Provider>
    </ContentBox>
  );
}
